import { createStyles } from 'game/lib/createStyles';

export const moduleStyles = createStyles({
  grab: {
    cursor: 'grab',
    opacity: 0,
  },
  grabbing: {
    cursor: 'grabbing',
  },
  hitBox: {
    cursor: 'pointer',
    opacity: 0,
    '&:focus': { outline: 'none' }, // TODO: Add :focus-visible state
  },
});
